import { defineNuxtPlugin } from '#app'
import { useRoute } from 'vue-router'

interface HeapWindow extends Window {
  heap?: any;
}

declare const window: HeapWindow

interface UserResponse {
  user: {
    id: number;
    name: string;
    email: string;
  } | null;
  organization?: {
    id: number;
    name: string;
  }
}

export default defineNuxtPlugin(async (nuxtApp) => {
  // Only run on client-side
  if (process.server) return

  const config = useRuntimeConfig()
  const route = useRoute()
  const heapId = config.public.heapId

  // Don't initialize if Heap is not configured
  if (!heapId) {
    console.debug('Heap is not configured, skipping initialization')
    return
  }

  // Initialize Heap
  window.heap = window.heap || []
  window.heap.load = function(e: string, t: any) {
    window.heap!.appid = e
    window.heap!.config = t = t || {}

    const r = document.createElement("script")
    r.type = "text/javascript"
    r.async = true
    r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js"

    const a = document.getElementsByTagName("script")[0]
    a?.parentNode?.insertBefore(r, a)

    for (var n = function(e: string) {
      return function() {
        heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
      }
    }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify",
            "resetIdentity", "removeEventProperty", "setEventProperties", "track",
            "unsetEventProperty"], o = 0; o < p.length; o++) {
      heap[p[o]] = n(p[o])
    }
  }

  // Load Heap with configured ID
  window.heap.load(heapId)

  // Initialize user data
  const initializeHeap = async () => {
    try {
      // Fetch user data
      const { data } = await useFetch<UserResponse>(`/api/${route.params.org_slug}/auth`, {
        headers: {
          Accept: 'application/json',
          'X-Api-Request': 'true'
        }
      })

      // Check if we have user data
      if (!data.value?.user) {
        console.debug('No authenticated user found')
        return
      }

      const userData = data.value.user

      // Identify user
      window.heap?.identify(userData.email)

      // Add user properties
      const properties: Record<string, any> = {
        'Boardable ID': userData.id,
        'Name': userData.name
      }

      // Add organization properties if available
      if (data.value.organization) {
        properties['Organization ID'] = data.value.organization.id
        properties['Organization Name'] = data.value.organization.name
      }

      window.heap?.addUserProperties(properties)

    } catch (error) {
      console.error('Failed to initialize Heap:', error)
    }
  }

  // Initialize when plugin loads
  await initializeHeap()
})